// src/components/EntityLink.js
// Componente universale per la Navigazione Contestuale Intelligente
// Uso: <EntityLink type="cliente" data={clienteObj}>Nome Cliente</EntityLink>
// Uso: <EntityLink type="commessa" data={projectObj}>Nome Commessa</EntityLink>
// Uso: <EntityLink type="dipendente" data={dipObj}>Nome Dipendente</EntityLink>
// Uso: <EntityLink type="task" data={taskObj}>Titolo Task</EntityLink>

import React from "react";
import { useNav } from "../contexts/NavContext";

// Stile base del link — inline, non rompe il layout circostante
const baseLinkStyle = {
  color: "#7c3aed",
  fontWeight: 600,
  cursor: "pointer",
  textDecoration: "none",
  borderBottom: "1px dashed #c4b5fd",
  transition: "color 0.15s, borderColor 0.15s",
  background: "none",
  border: "none",
  padding: 0,
  font: "inherit",
  display: "inline",
};

const hoverStyle = {
  color: "#5b21b6",
  borderBottomColor: "#7c3aed",
  borderBottomStyle: "solid",
};

export default function EntityLink({ type, data, children, style = {}, fallback = null }) {
  const nav = useNav();
  const [hovered, setHovered] = React.useState(false);

  // Se non c'è data o id, mostra il testo semplice senza link
  if (!data || (!data.id && !data.uid)) {
    return <span style={style}>{children || fallback || "—"}</span>;
  }

  const handleClick = (e) => {
    e.stopPropagation();
    nav.openEntity(type, data);
  };

  return (
    <button
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        ...baseLinkStyle,
        ...(hovered ? hoverStyle : {}),
        ...style,
      }}
      title={`Apri scheda ${type}`}
    >
      {children || data.name || data.ragioneSociale || data.nome || data.cognome || "—"}
    </button>
  );
}

// ─── Varianti tipizzate (shortcut) ────────────────────────────────────────────

export function ClienteLink({ cliente, children, style }) {
  return (
    <EntityLink type="cliente" data={cliente} style={style}>
      {children || cliente?.ragioneSociale || cliente?.nome || "—"}
    </EntityLink>
  );
}

export function CommessaLink({ commessa, children, style }) {
  return (
    <EntityLink type="commessa" data={commessa} style={style}>
      {children || commessa?.name || "—"}
    </EntityLink>
  );
}

export function DipendenteLink({ dipendente, children, style }) {
  return (
    <EntityLink type="dipendente" data={dipendente} style={style}>
      {children || `${dipendente?.nome || ""} ${dipendente?.cognome || ""}`.trim() || "—"}
    </EntityLink>
  );
}

export function TaskLink({ task, children, style }) {
  return (
    <EntityLink type="task" data={task} style={style}>
      {children || task?.title || "—"}
    </EntityLink>
  );
}
